import React from "react";
import { Mode } from "@/enum";

const { Preclaim, Mint } = Mode;

interface HeaderProps {
  mode: Mode;
  onModeChange: (mode: Mode) => void;
  isWhitelistOver: boolean;
}

const Header: React.FC<HeaderProps> = ({
  mode,
  onModeChange,
  isWhitelistOver,
}: HeaderProps) => {
  return (
    <header className="header">
      <button
        className="button-flat nav-button"
        disabled={mode === Mint || !isWhitelistOver}
        onClick={() => onModeChange(Mint)}
      >
        Boxes — Collection
      </button>
      <button
        className="button-flat nav-button"
        disabled={mode === Preclaim || isWhitelistOver}
        onClick={() => onModeChange(Preclaim)}
      >
        Whitelist
      </button>
    </header>
  );
};

export default Header;
